export class AuthTokenExpired extends Error {
  constructor(message = "Auth token expired") {
    super(message);
  }
}
